<template>
  <v-dialog v-model="dialog" scrollable persistent width="900">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <v-card flat tile color="white">
      <v-card-title class="dialog-header-title">{{ title }}</v-card-title>

      <v-alert v-model="alert" :type="alertType" dismissible>{{ alertMessage }}</v-alert>
      <v-card-text class="py-1">
        <v-row no-gutters>
          <v-col>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <span>Identifier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.customer_rank_id"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Label:</span>
                <input class="form-control" v-model="selectedCustomerRank.label" />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Currency:</span>
                <v-select
                  :items="currencies"
                  solo
                  flat
                  class="form-control"
                  v-model="selectedCustomerRank.currency"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="4">
                <span>Air freight rates multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.air_freight_markup_rate"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>FCL freight rates multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.ocean_freight_fcl_markup_rate"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>LCL freight rates multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.ocean_freight_lcl_markup_rate"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="4">
                <span>Insurance processing fee:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.insurance_processing_fee"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Haulage rate multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.haulage_markup_rate"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Transport rate multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.transport_markup_rate"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="4">
                <span>Handling fee (Air):</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.air_handling_fee"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Handling fee (FCL):</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.fcl_handling_fee"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Handling fee (LCL):</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.lcl_handling_fee"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="4">
                <span>Container freight station rate multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.container_freight_station_markup_rate"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Export forwarding rate multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.fwd_export_markup_rate"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <span>Import forwarding rate multiplier:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.fwd_import_markup_rate"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="3">
                <span>Credit term days:</span>
                <input
                  class="form-control"
                  v-model="selectedCustomerRank.credit_term_days"
                />
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <span>Credit line:</span>
                <input class="form-control" v-model="selectedCustomerRank.credit_line" />
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <div
                  class="custom-control custom-checkbox"
                  style="height: 36px; padding-top: 25px; display: inline-block"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="apply_minimum_markup"
                    v-model="selectedCustomerRank.apply_minimum_markup"
                  />
                  <label class="custom-control-label" for="apply_minimum_markup"
                    >Apply minimum rate</label
                  >
                </div>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <div
                  class="custom-control custom-checkbox"
                  style="height: 36px; padding-top: 25px; display: inline-block"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="automate_workflow"
                    v-model="selectedCustomerRank.automate_workflow"
                  />
                  <label class="custom-control-label" for="automate_workflow"
                    >Automate Workflow</label
                  >
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mb-3">
        <v-row justify="end">
          <v-btn
            @click="onSave"
            class="mr-2 font-weight-bold"
            color="primary"
            tile
            depressed
            >SAVE</v-btn
          >
          <v-btn
            @click="onDialogClose"
            class="ml-2 font-weight-bold"
            color="error"
            tile
            depressed
            >CLOSE</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";

export default {
  props: ["dialog", "customerRank"],

  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,
      alert: false,
      alertType: "success",
      alertMessage: null,
      title: null,

      CONSTANTS: constant,
      currencies: [],

      selectedCustomerRank: {
        apply_minimum_markup: true,
        automate_workflow: false,
        container_freight_station_markup_rate: 0,
        credit_term_days: 0,
        credit_line: 0,
        currency: "MYR",
        customer_rank_id: null,
        fwd_export_markup_rate: 0,
        fwd_import_markup_rate: 0,
        insurance_processing_fee: 0,
        label: null,
        air_handling_fee: 0,
        fcl_handling_fee: 0,
        lcl_handling_fee: 0,
        air_freight_markup_rate: 0,
        ocean_freight_fcl_markup_rate: 0,
        ocean_freight_lcl_markup_rate: 0,
        haulage_markup_rate: 0,
        transport_markup_rate: 0,
      },
    };
  },

  created() {
    // fetch currencies
    this.loadCurrenciesList();
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.resetCustomerRank();
        if (this.customerRank != null) {
          this.selectedCustomerRank = this.customerRank;
        }

        if (this.selectedCustomerRank.customer_rank_id == null) {
          this.title = "Create new customer rank";
        } else {
          this.title = "Edit " + this.selectedCustomerRank.label;
        }
      }
    },
  },

  methods: {
    /**
     * Get currencies list
     */
    loadCurrenciesList() {
      this.$https.get("/api/currencies/list/dropdown").then((resp) => {
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.currencies = resp.data.data;
        } else {
          this.currencies = [];
        }
      });
    },

    onDialogClose() {
      this.$emit("dialog-close", constant.DIALOG_CUSTOMER_RANK, this.hasChange);
    },

    onSave() {
      var response = null;
      this.$root.blockUImsg = "Saving customer rank...";
      this.$root.blockUIshow = true;

      this.$https
        .post("/api/company/rates/customer_ranks", this.selectedCustomerRank)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          response = err.response;
        })
        .finally(() => {
          if (response != null) {
            if (response.status == constant.RESPONSE_STATUS_OK) {
              this.selectedCustomerRank = response.data;
              this.showSnackbar = true;
              this.snackbarColor = "success";
              this.snackbarMsg = "Customer rank successfully updated";
              this.hasChange = true;
            } else {
              this.showSnackbar = true;
              this.snackbarColor = "error";
              this.snackbarMsg = response.msg;
            }
          }

          this.$root.blockUIshow = false;
        });
    },

    resetCustomerRank() {
      this.selectedCustomerRank = {
        apply_minimum_markup: true,
        automate_workflow: false,
        container_freight_station_markup_rate: 0,
        credit_term_days: 0,
        credit_line: 0,
        currency: "MYR",
        customer_rank_id: null,
        fwd_export_markup_rate: 0,
        fwd_import_markup_rate: 0,
        insurance_processing_fee: 0,
        label: null,
        air_handling_fee: 0,
        fcl_handling_fee: 0,
        lcl_handling_fee: 0,
        air_freight_markup_rate: 0,
        ocean_freight_fcl_markup_rate: 0,
        ocean_freight_lcl_markup_rate: 0,
        haulage_markup_rate: 0,
        transport_markup_rate: 0,
      };
    },
  },
};
</script>

<style></style>
